<section class="section" *ngIf="data">
    <div class="container">
        <div class="content">
            <div class="headline">
                <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">
                    {{ headlineText }}
                </app-spot-headline>
            </div>
            <p class="paragraph" *ngIf="data.paragraph as paragraph">
                {{ paragraph }}
            </p>
            <div class="row-wrapper">
                <article class="item" [ngClass]="{ 'kk-hover-opacity': item.link }" *ngFor="let item of data.entrances">
                    <app-image
                        [image]="item.image"
                        [height]="130"
                        [width]="400"
                        crop="min"
                        format="none"
                        *ngIf="item.image"
                    ></app-image>

                    <a
                        *ngIf="item.link as itemLink"
                        [routerLink]="itemLink.url"
                        [target]="itemLink.target || ''"
                        class="link kk-link-cover"
                    >
                        <span class="kk-visuallyhidden"> {{ itemLink.name }} </span>
                    </a>
                </article>
            </div>

            <footer *ngIf="data.link as link">
                <a class="kk-btn kk-btn_secondary" [routerLink]="link.url">
                    {{ link.name }}
                </a>
            </footer>
        </div>
    </div>
</section>
